import { render } from "./KnowledgeGraph3D.vue?vue&type=template&id=6b269d7c&scoped=true"
import script from "./KnowledgeGraph3D.vue?vue&type=script&lang=js"
export * from "./KnowledgeGraph3D.vue?vue&type=script&lang=js"

import "./KnowledgeGraph3D.vue?vue&type=style&index=0&id=6b269d7c&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6b269d7c"]])

export default __exports__